var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"kt-login-v2__container"},[(_setup.page === _setup.AuthPage.LOGIN)?_c(_setup.LoginForm):(_setup.page === _setup.AuthPage.FORGET_PASSWORD)?_c(_setup.ForgotPasswordForm):(_setup.page === _setup.AuthPage.TWO_FACTOR_AUTH)?_c(_setup.TwoFactorAuthentication):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }